import { Component, OnInit } from '@angular/core';
import { ChatService } from '../../services/chat.service';
import { NavController, ViewController, Platform, NavParams } from 'ionic-angular';
import { DaikeWindowPage } from '../daike-window/daike-window';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { SysconfigService } from '../../services/sysconfig.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { RechargeService } from '../../services/recharge.service';
import { AppConfig } from '../../app/app.config';

@Component({
    selector: 'daike-modal',
    templateUrl: './daike-modal.html',
    providers: [ChatService, SysconfigService, RechargeService]
})
export class DaikeModalPage implements OnInit {
    daikeParams
    daikeCode = [];
    isAndroid;
    registerUrl = [];
    payUrl: string;
    constructor(
        private chatService: ChatService,
        private navCtrl: NavController,
        private viewCtrl: ViewController,
        private platform: Platform,
        private config: AppConfig,
        private iab: InAppBrowser,
        private sysconfigService: SysconfigService,
        private sanitizer: DomSanitizer,
        private navPar: NavParams,
        private recharge: RechargeService
    ) {
        this.payUrl = this.navPar.data.url;
    }

    ngOnInit() {
        // this.getlink();
        this.getAuthCode();
    }

    /*
    * 获取代客充值暗号
    */
    getAuthCode() {
        this.recharge.getPayTheSecretCode().then(res => {
            if (res) {
                this.daikeParams = res;
                this.daikeCode = res.split("");
            }
        })
    }

    /** 代客充值客服地址 */
    // async getPayUrl() {
    //     await this.chatService.getPayUrl().then(res => {
    //         if (res) {
    //             this.payUrl = res;
    //         }
    //     }).catch(err => { console.log(err); })
    // }


    /**
     * 跳转客服窗口
     */
    getDaiKeUrl() {
        this.isAndroid = this.platform.is('android');
        if (this.isAndroid) {
            // await this.getPayUrl();
            let daike = this.registerUrl[0].LineUrl + '?daike=' + this.daikeParams + '&isWap=true' + '&payurl=' + encodeURIComponent(this.payUrl);
            this.config.openUrl(daike);
        } else {
            this.navCtrl.push(DaikeWindowPage, { key: this.daikeParams, url: this.payUrl })
        }
    }
    getlink() {
        this.sysconfigService.getPlatformLineList().then(res => {
            if (res) {
                res.forEach(e => {
                    if (e.LineType == 3) {
                        this.registerUrl.push(e);
                    }
                });
            }
        })
    }

    close() {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/pages/daike-modal/daike-modal.ts